/* eslint-disable react/require-default-props */
import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { compose } from 'recompose';
import get from 'lodash/get';
import classNames from 'classnames';
import CSSModules from 'react-css-modules';

import { injectIntl } from 'react-intl';
import Logo from './Logo';
import Title from './Title';
import NewPostButton from './NewPost';
import ClickableElement from '../ClickableElement';
import Icon from '../Icon';

import { isDesktop } from '../../utils/mobileHelpers';
import { COLORS } from '../../constants/styles';
import {
  currentCommunityInfoSelector,
  isCurrentCommunityModeratorSelector,
} from '../../redux/communities/selectors/currentCommunity';
import { communityPreviewSelector } from '../../redux/communities/selectors/communityPreview';
import { isLoggedInSelector } from '../../redux/auth/selectors';
import { actions as uiSidebarActions } from '../../redux/ui/sidebar';

import styles from './index.styl';

const Heading = ({
  clipped,
  offset,
  params,
  currentCommunityInfo,
  toggleSidebarVisibility,
  communityPreview,
  isLoggedIn,
  isModerator,
  updateImage,
  removeImage,
  intl: { formatMessage },
}) => {
  const community = isLoggedIn ? currentCommunityInfo : communityPreview;

  if (!community) return null;

  const handleLogoCrop = useCallback(data => {
    updateImage({ logo: data });
  }, []);
  const handleImageRemove = useCallback(() => {
    removeImage({ data: { logo: true } });
  }, []);

  const {
    logo,
    totalUsers,
    name,
    organization,
    type,
    accessLevel,
    totalPosts,
  } = community;

  const getLogoSize = () => {
    if (clipped) return 40;
    if (isDesktop()) return 120;
    return 60;
  };

  const isCommunityPage = params.communityId && !params.postId;
  const organizationName = get(organization, 'name');

  return (
    <div
      styleName={classNames('heading', {
        'heading--clipped': clipped,
        'heading--offset': offset,
      })}
    >
      <div styleName="heading__image">
        <div className="flex items-center">
          <Logo
            size={getLogoSize()}
            onImageRemove={handleImageRemove}
            onImageCrop={handleLogoCrop}
            isModerator={isModerator}
            formatMessage={formatMessage}
            image={logo}
            offset={offset}
            name={name}
          />
          {!isDesktop() && (
            <div className="ml1">
              <div styleName="heading__image-title">{name}</div>
              <div styleName="heading__image-subtitle">{organizationName}</div>
            </div>
          )}
        </div>
        {!isDesktop() && (
          <ClickableElement onClick={() => toggleSidebarVisibility()}>
            <Icon
              name="arrow-down"
              width={16}
              height={16}
              style={{
                fill: COLORS.white,
                stroke: COLORS.white,
                transform: 'rotate(-90deg)',
              }}
            />
          </ClickableElement>
        )}
      </div>
      <div styleName="heading__content">
        <div styleName="heading__title">
          <Title
            {...{
              totalUsers,
              name,
              organizationName,
              type,
              accessLevel,
              totalPosts,
            }}
          />
        </div>
        <If condition={isCommunityPage}>
          <NewPostButton
            community={community}
            accessLevel={accessLevel}
            isModerator={isModerator}
          />
        </If>
      </div>
    </div>
  );
};

Heading.propTypes = {
  clipped: PropTypes.bool,
  offset: PropTypes.bool,
  params: PropTypes.shape({
    communityId: PropTypes.string,
    postId: PropTypes.string,
  }),
  userCommunities: PropTypes.shape({
    list: PropTypes.array,
  }),
  currentCommunityInfo: PropTypes.object,
  toggleSidebarVisibility: PropTypes.func,
  communityPreview: PropTypes.object,
  isLoggedIn: PropTypes.bool,
  isModerator: PropTypes.bool.isRequired,
  intl: PropTypes.object.isRequired,
  updateImage: PropTypes.func,
  removeImage: PropTypes.func,
};

const mapStateToProps = state => ({
  currentCommunityInfo: currentCommunityInfoSelector(state),
  communityPreview: communityPreviewSelector(state),
  isLoggedIn: isLoggedInSelector(state),
  isModerator: isCurrentCommunityModeratorSelector(state),
});

const mapDispatchToProps = {
  toggleSidebarVisibility: uiSidebarActions.toggleVisibility,
};

export default compose(
  injectIntl,
  withRouter,
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  CSSModules(styles, { allowMultiple: true }),
)(Heading);



// WEBPACK FOOTER //
// ./src/components/Community/Heading.jsx